import jsPDF from "jspdf"

let cachedBase64: string | null = null

export async function loadPdfFont(doc: jsPDF) {
  if (!cachedBase64) {
    const res = await fetch("/fonts/DejaVuSans.ttf")
    const buf = await res.arrayBuffer()
    const bytes = new Uint8Array(buf)
    let binary = ""
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    cachedBase64 = btoa(binary)
  }
  doc.addFileToVFS("DejaVuSans.ttf", cachedBase64)
  doc.addFont("DejaVuSans.ttf", "DejaVuSans", "normal")
}
